module.exports = __webpack_public_path__ + "img/20FT.541eefbf.svg";